export default __webpack_public_path__ + "static/dudutgt-1f2697d3089e3908573cb9e6bc04fc1a.png";